__turbopack_context__.v({
  "breadcrumb": "course-lede-module-scss-module__D37FTG__breadcrumb",
  "container": "course-lede-module-scss-module__D37FTG__container",
  "expanded-captions": "course-lede-module-scss-module__D37FTG__expanded-captions",
  "google-logo": "course-lede-module-scss-module__D37FTG__google-logo",
  "headline": "course-lede-module-scss-module__D37FTG__headline",
  "instructor-section": "course-lede-module-scss-module__D37FTG__instructor-section",
  "last-updated-languages-container": "course-lede-module-scss-module__D37FTG__last-updated-languages-container",
  "metadata": "course-lede-module-scss-module__D37FTG__metadata",
  "metadata-container": "course-lede-module-scss-module__D37FTG__metadata-container",
  "rating-container": "course-lede-module-scss-module__D37FTG__rating-container",
  "rating-count": "course-lede-module-scss-module__D37FTG__rating-count",
  "rating-score": "course-lede-module-scss-module__D37FTG__rating-score",
  "rating-stars": "course-lede-module-scss-module__D37FTG__rating-stars",
  "title": "course-lede-module-scss-module__D37FTG__title",
});
